module.exports = __webpack_public_path__ + "static/media/information-icon.8f1295cd.svg";